import { render, staticRenderFns } from "./DettaglioVoto.vue?vue&type=template&id=d30f36ba&"
import script from "./DettaglioVoto.vue?vue&type=script&lang=js&"
export * from "./DettaglioVoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports